import { render, staticRenderFns } from "./AddStudents.vue?vue&type=template&id=4ca888cd&scoped=true"
import script from "./AddStudents.vue?vue&type=script&lang=js"
export * from "./AddStudents.vue?vue&type=script&lang=js"
import style0 from "./AddStudents.vue?vue&type=style&index=0&id=4ca888cd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ca888cd",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VInput } from 'vuetify/lib/components/VInput';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
installComponents(component, {VForm,VIcon,VInput,VListItemContent,VListItemTitle})
